import {
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Box,
} from "@mui/material";
import {
  InputDiv,
  SummaryDiv,
  RadioDiv,
  InputRow,
  StyledBox,
  InputDivFull,
} from "../styles";
import { useEffect } from "react";
import { Input } from "../../../Input";
import { OthersFieldType, RsvpType } from "../../../../types/rsvp/index";
import { FormProvider, useForm } from "react-hook-form";
import { useRsvp } from "../../../../contexts/rsvp.context";
import ColorToggleButton from "../../../ToggleButtonGroup";

type Props = {
  onSubmitNav: () => void;
  isDisabled: boolean;
};

export function Others({ onSubmitNav, isDisabled }: Props) {
  const { rsvpId, updateOthers, createRsvp, others } = useRsvp();
  const obj: OthersFieldType = {
    rsvpReport: "",
    detailsToAskForObs: "",
    costumeObs: "",
  };
  const methods = useForm({
    defaultValues: obj,
  });
  const { handleSubmit, register, watch, setValue, reset, control } = methods;

  function onSubmit(form: OthersFieldType) {
    rsvpId ? updateOthers(form) : createRsvp({ others: form } as RsvpType);
    onSubmitNav();
  }

  useEffect(() => {
    if (others) {
      reset(others);
    }
  }, [others]);

  return (
    <FormProvider {...methods}>
      <StyledBox onSubmit={handleSubmit(onSubmit)} style={{ marginLeft: 16 }}>
        <h3>8.Outros</h3>
        <InputDivFull>
          <SummaryDiv>
            <strong>Detalhe para perguntar antes de RSVP</strong>
          </SummaryDiv>
          <RadioDiv>
            <Input
              fullWidth
              label="Outros"
              placeholder="Especifique"
              multiline
              size="small"
              {...register("detailsToAskForObs")}
            />
          </RadioDiv>
        </InputDivFull>
        <InputDivFull>
          <SummaryDiv>
            <strong>Traje ou tamanho de camiseta</strong>
          </SummaryDiv>
          <RadioDiv>
            <Input
              fullWidth
              label="Outros"
              placeholder="Especifique"
              type="text-area"
              multiline
              size="small"
              {...register("costumeObs")}
            />
          </RadioDiv>
        </InputDivFull>
        <InputDivFull style={{ marginTop: 16 }}>
          <SummaryDiv>
            <strong>Relatório RSVP tradicional (planilha/tabela)</strong>
            <span style={{ color: "#A1A1A1" }}>
              Definir frequencia de envio
            </span>
          </SummaryDiv>
          <RadioDiv>
            {/* <RadioGroup
              value={watch("rsvpReport")}
              onChange={(e) => setValue("rsvpReport", e.target.value)}
            >
              <FormControlLabel
                value="NO_SERVICE_USAGE_FOR_COMPANIONS"
                control={<Radio />}
                label="Acompanhantes não podem usufruir do serviço (conforme padrão de compliance)"
              />
            </RadioGroup> */}

            <span style={{ marginBottom: 8 }}>
              Acompanhantes não podem usufruir do serviço (conforme padrão de
              compliance)
            </span>

            <ColorToggleButton
              name="rsvpReport"
              options={[
                { label: "Sim", value: "NO_SERVICE_USAGE_FOR_COMPANIONS" },
                { label: "Não", value: "" },
              ]}
              control={control}
            />
          </RadioDiv>
        </InputDivFull>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            marginTop: 2,
          }}
        >
          <Button variant="contained" disabled={isDisabled} type="submit">
            Salvar
          </Button>
        </Box>
      </StyledBox>
    </FormProvider>
  );
}
